import React from 'react';

import { useTranslation } from 'react-i18next';

import { PlanUnit, PlanUnitLink } from '../types';

import { Drawer } from 'components/shared';

import { LinkPlanUnitDetailsLoaderFeedback } from './LinkPlanUnitDetailsLoaderFeedback';
import { HierarchyPlanUnit } from './utils/treeHierarchy';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedRow: PlanUnit;
  mode?: PlanUnitLink;
  hierarchy: PlanUnit[] | HierarchyPlanUnit[] | undefined;
}

export const LinkPlanUnitDrawer: React.FC<Props> = ({
  open,
  onClose,
  selectedRow,
  mode,
  hierarchy
}) => {
  const { t } = useTranslation();

  const modeLabel = t(mode ?? '');
  const title = `${modeLabel?.[0]?.toUpperCase()}${modeLabel?.slice(1)}`;

  return (
    <Drawer open={open} onClose={onClose} title={t('linkTo', { mode: title })}>
      <LinkPlanUnitDetailsLoaderFeedback
        onClose={onClose}
        mode={mode}
        selectedRow={selectedRow}
        hierarchy={hierarchy}
      />
    </Drawer>
  );
};
